// extracted by mini-css-extract-plugin
module.exports = {"relatedSearchesContainer":"RelatedSearches_relatedSearchesContainer__BwFlj","leftToRight":"RelatedSearches_leftToRight__xudNH"};